module.exports = __webpack_public_path__ + "application/icons/support.png";